/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { ModalProvider } from 'react-simple-hook-modal';
import { ToastContainer } from 'react-toastify';

import Routes from './app/Routes';
import history from './app/services/history';

import { ApiStrategyContext } from './app/context/api-strategy-context';
import { CreateApiStrategy } from './app/main/factories/strategy/create-api-strategy';
import { ApplicationConstants, token } from './app/constants/application';

import GlobalStyle from './app/styles/global';

const App: React.FC = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
    link.href = ApplicationConstants.SAAS_FAVICON;
  }, []);

  return (
    <ApiStrategyContext.Provider
      value={{
        api: new CreateApiStrategy(
          token,
          ApplicationConstants.SAAS_NAME
        ).execute(),
      }}
    >
      <Router history={history}>
        <GlobalStyle />
        <ModalProvider>
          <ToastContainer />
          <Routes />
        </ModalProvider>
      </Router>
    </ApiStrategyContext.Provider>
  );
};

export default App;
